import { defineMessages } from 'react-intl';

export const recaptchaMessages = defineMessages({
    actionMismatch: {
        id: 'recaptcha.error.action_mismatch',
        defaultMessage: 'Security verification failed. Please try again.',
    },
    tokenExpired: {
        id: 'recaptcha.error.token_expired',
        defaultMessage: 'Security check expired. Please try again.',
    },
    invalidToken: {
        id: 'recaptcha.error.invalid_token',
        defaultMessage: 'Invalid security token. Please try again.',
    },
    v2Disabled: {
        id: 'recaptcha.error.v2_disabled',
        defaultMessage: 'Additional verification is required but unavailable.',
    },
    hostnameMismatch: {
        id: 'recaptcha.error.hostname_mismatch',
        defaultMessage: 'Security verification failed. Please refresh the page.',
    },
    verificationFailed: {
        id: 'recaptcha.error.verification_failed',
        defaultMessage: 'Unable to verify. Please try again later.',
    },
    v2Required: {
        id: 'recaptcha.v2.required',
        defaultMessage: 'Please complete the security check to continue.',
    },
    v2Expired: {
        id: 'recaptcha.v2.expired',
        defaultMessage: 'Security check expired. Please try again.',
    },
    v2Failed: {
        id: 'recaptcha.v2.failed',
        defaultMessage: 'Security check failed. Please try again.',
    },
    unsupportedVersion: {
        id: 'recaptcha.error.unsupported_version',
        defaultMessage: 'Unsupported security verification version.',
    },
});
